import { render } from "./FAQView.vue?vue&type=template&id=4b20fc2e&scoped=true"
import script from "./FAQView.vue?vue&type=script&lang=js"
export * from "./FAQView.vue?vue&type=script&lang=js"

import "./FAQView.vue?vue&type=style&index=0&id=4b20fc2e&lang=less&scoped=true"
import "./FAQView.vue?vue&type=style&index=1&id=4b20fc2e&lang=less"

import exportComponent from "/Users/kacper/IdeaProjects/e.on-portal-awarie/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b20fc2e"]])

export default __exports__